var _rect, _rect2, _rect3, _rect4, _path, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemLayoutCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 58,
    viewBox: "0 0 118 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 58,
    rx: 5,
    fill: "#EAEAEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 10.5,
    width: 49,
    height: 4,
    rx: 1.5,
    fill: "#B4B3B3",
    stroke: "#939393"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 20.5,
    width: 93,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 30.5,
    width: 63,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3643 39.7529V41.2129H58.6123V39.7529H59.3643ZM59.2715 47.7266V49.0352H58.5244V47.7266H59.2715ZM60.0088 46.1494C60.0088 45.9606 59.9697 45.7962 59.8916 45.6562C59.8167 45.513 59.693 45.3844 59.5205 45.2705C59.348 45.1533 59.1169 45.0443 58.8271 44.9434C58.4105 44.7969 58.0459 44.6325 57.7334 44.4502C57.4242 44.2646 57.1833 44.0368 57.0107 43.7666C56.8415 43.4932 56.7568 43.153 56.7568 42.7461C56.7568 42.3457 56.848 41.999 57.0303 41.7061C57.2158 41.4131 57.473 41.1868 57.8018 41.0273C58.1305 40.8678 58.5146 40.7881 58.9541 40.7881C59.2926 40.7881 59.597 40.8385 59.8672 40.9395C60.1406 41.0404 60.3734 41.1885 60.5654 41.3838C60.7575 41.5791 60.904 41.82 61.0049 42.1064C61.109 42.3896 61.1611 42.7152 61.1611 43.083H59.9893C59.9893 42.8747 59.9648 42.6891 59.916 42.5264C59.8704 42.3604 59.8021 42.2204 59.7109 42.1064C59.6198 41.9893 59.5091 41.8997 59.3789 41.8379C59.252 41.776 59.1071 41.7451 58.9443 41.7451C58.7132 41.7451 58.5228 41.7891 58.373 41.877C58.2233 41.9616 58.1126 42.0788 58.041 42.2285C57.9727 42.3783 57.9385 42.5492 57.9385 42.7412C57.9385 42.9268 57.9743 43.0895 58.0459 43.2295C58.1175 43.3695 58.2396 43.4964 58.4121 43.6104C58.5879 43.721 58.8288 43.8333 59.1348 43.9473C59.5547 44.097 59.9176 44.2646 60.2236 44.4502C60.5329 44.6325 60.7705 44.8587 60.9365 45.1289C61.1058 45.3958 61.1904 45.7327 61.1904 46.1396C61.1904 46.5596 61.0928 46.916 60.8975 47.209C60.7054 47.502 60.4352 47.7249 60.0869 47.8779C59.7419 48.0277 59.3398 48.1025 58.8809 48.1025C58.5911 48.1025 58.3031 48.0651 58.0166 47.9902C57.7334 47.9121 57.4762 47.7852 57.2451 47.6094C57.014 47.4336 56.8301 47.2008 56.6934 46.9111C56.5566 46.6182 56.4883 46.2601 56.4883 45.8369H57.6699C57.6699 46.0908 57.7041 46.3024 57.7725 46.4717C57.8408 46.641 57.9336 46.7744 58.0508 46.8721C58.168 46.9697 58.2982 47.0397 58.4414 47.082C58.5879 47.1243 58.7344 47.1455 58.8809 47.1455C59.125 47.1455 59.3301 47.1048 59.4961 47.0234C59.6654 46.9388 59.7923 46.8216 59.877 46.6719C59.9648 46.5189 60.0088 46.3447 60.0088 46.1494Z",
    fill: "#3A3A3A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 117,
    height: 57,
    rx: 4.5,
    stroke: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemLayoutCenter);
export default __webpack_public_path__ + "static/media/ItemLayoutCenter.96d6edf42355c71f310c11c682b5fd4b.svg";
export { ForwardRef as ReactComponent };